import { isEmpty } from 'underscore';

export const POINT_NAME_MAX_LENGTH = 25 as const;

const POINT_NAME_FORBIDDEN_CHARS_REGEX = /[&%*/`<>.\u00A7-]/;

export const isPointNameValid = (pointName: string) => {
  if (pointName.length > POINT_NAME_MAX_LENGTH) {
    return false;
  }

  return !POINT_NAME_FORBIDDEN_CHARS_REGEX.test(pointName);
};

export const isPointNameDefined = (pointName: string) => {
  return !isEmpty(pointName);
};

export const POINT_NAME_VALIDATION_MESSAGE = `- Max ${POINT_NAME_MAX_LENGTH} characters.\n- Cannot include: & % * / - § < > .`;
export const EMPTY_POINT_NAME_MESSAGE = 'Point name cannot be empty';
